document.querySelectorAll('[data-content-nav]').forEach(wrapper => {

  const contentNav = wrapper.querySelector('.news-content-nav');
  const contentHolder = wrapper.querySelector('.news-detail-content');

  const threshold = 160;

  const onScroll = () => {
    const holderRect = contentHolder.getBoundingClientRect();
    let newTop = holderRect.top;

    if (newTop < threshold)  {
      newTop = threshold;
    }


    window.requestAnimationFrame(() => {
      contentNav.style.top = `${newTop}px`;
    });
  }

  window.addEventListener('scroll', () => onScroll());

  onScroll();


  const links = wrapper.querySelectorAll('.news-content-nav a');
  const linkActiveClass = 'active';
  const items =  [];

  links.forEach(link => {
    const id = link.getAttribute('href').replace('#', '');
    const target = document.getElementById(id);
    const block = target.closest('.block');
    if (block) {
      items.push({
        id,
        link,
        target,
        block,
      });
    }
  });


  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {

      const id = entry.target.querySelector('.news-block-anchor').getAttribute('id');
      const item = items.find(i => i.id === id);
      console.log(id, entry.isIntersecting, entry);

      if (item) {
        if (entry.isIntersecting) {
          item.link.classList.add(linkActiveClass);
        } else {
          item.link.classList.remove(linkActiveClass);
        }
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.4,
  });

  items.forEach(item => {
    observer.observe(item.block);
  });

})
